import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b0a8bad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "newCustomResource" }
const _hoisted_2 = { class: "statitiscal" }
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = { class: "total" }
const _hoisted_5 = { class: "divide" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总客户数:", -1))
const _hoisted_7 = { class: "inner_number" }
const _hoisted_8 = { class: "total" }
const _hoisted_9 = { class: "divide" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回复＞1条:", -1))
const _hoisted_11 = { class: "inner_number_reply" }
const _hoisted_12 = { class: "divide" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_14 = { class: "inner_number_reply" }
const _hoisted_15 = { class: "total" }
const _hoisted_16 = { class: "divide" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回复＞3条:", -1))
const _hoisted_18 = { class: "inner_number_reply" }
const _hoisted_19 = { class: "divide" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_21 = { class: "inner_number_reply" }
const _hoisted_22 = { class: "total" }
const _hoisted_23 = { class: "divide" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回复＞5条:", -1))
const _hoisted_25 = { class: "inner_number_reply" }
const _hoisted_26 = { class: "divide" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_28 = { class: "inner_number_reply" }
const _hoisted_29 = { class: "total" }
const _hoisted_30 = { class: "divide" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回复＞10条:", -1))
const _hoisted_32 = { class: "inner_number_reply" }
const _hoisted_33 = { class: "divide" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_35 = { class: "inner_number_reply" }
const _hoisted_36 = { class: "total" }
const _hoisted_37 = { class: "divide" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当天删除:", -1))
const _hoisted_39 = { class: "inner_number_delete" }
const _hoisted_40 = { class: "divide" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_42 = { class: "inner_number_delete" }
const _hoisted_43 = { class: "total" }
const _hoisted_44 = { class: "divide" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "一周内删除:", -1))
const _hoisted_46 = { class: "inner_number_delete" }
const _hoisted_47 = { class: "divide" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_49 = { class: "inner_number_delete" }
const _hoisted_50 = { class: "total" }
const _hoisted_51 = { class: "divide" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资金量＜5w:", -1))
const _hoisted_53 = { class: "inner_number" }
const _hoisted_54 = { class: "divide" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_56 = { class: "inner_number" }
const _hoisted_57 = { class: "total" }
const _hoisted_58 = { class: "divide" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资金量5w-10w:", -1))
const _hoisted_60 = { class: "inner_number_reply" }
const _hoisted_61 = { class: "divide" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_63 = { class: "inner_number_reply" }
const _hoisted_64 = { class: "total" }
const _hoisted_65 = { class: "divide" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "资金量＞10w:", -1))
const _hoisted_67 = { class: "inner_number_delete" }
const _hoisted_68 = { class: "divide" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_70 = { class: "inner_number_delete" }

import { useStore } from '@/store'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { initEmptyParam } from '@/hooks/useInitParam'
import { getBeforeDate } from '@/utils/utils'
import { getListData, queryStatistical } from '@/service/main/system'
import { secondToString } from '@/utils/date-format'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Statistic',
  setup(__props) {

const store = useStore()

initEmptyParam()
const userInfo = store.state.login.userInfo
let queryParam = ref()
if (store.state.login.userInfo.isManager != '1') {
  queryParam.value = {
    date: [getBeforeDate('7_days'), new Date().toISOString().slice(0, 10)],
    usedBy: userInfo.realName,
    pageNo: 1,
    pageSize: 10
  }
} else {
  queryParam.value = {
    date: [getBeforeDate('7_days'), new Date().toISOString().slice(0, 10)],
    pageNo: 1,
    pageSize: 10
  }
}

store.commit('system/changeQueyryInfo', queryParam.value)
const statitiscal = ref({
  totalCount: 0,
  replyOneCount: 0,
  replyOnePercent: '0%',
  replyThreeCount: 0,
  replyThreePercent: '0%',
  replyFiveCount: 0,
  replyFivePercent: '0%',
  replyTenCount: 0,
  replyTenPercent: '0%',
  dayDeleteCount: 0,
  dayDeletePercent: '0%',
  weekDeleteCount: 0,
  weekDeletePercent: '0%',
  funds0wTo5wCount: 0,
  funds0wTo5wPercent: '0%',
  funds5wTo10wCount: 0,
  funds5wTo10wPercent: '0%',
  funds10wCount: 0,
  funds10wPercent: '0%'
})
const searchCb = async (item: any) => {
  statitiscal.value = await queryStatistical(
    '/main/newCustomResource/querySummaryData',
    item
  )
}

searchCb(queryParam.value)

const resetCb = () => {
  return queryParam.value
}

const getUsedBy = async () => {
  let userList = await getListData(
    '/main/enterpriseWechat/dingUser/listAll',
    {}
  )
  const userOptions = userList.map((item: any) => {
    return {
      title: item.userName,
      value: item.userName
    }
  })
  const usedByItem = searchFormConfig.formItems.find(
    (item) => item.field === 'usedBy'
  )
  usedByItem!.options = userOptions
}
getUsedBy()

const handleChange = (formData: any) => {
  store.commit('system/changeQueyryInfo', formData)
}

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpId'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.name, value: item.corPid }
  })
}

getCompanyList()

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb, searchCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      modelValue: _unref(initEmptyParam),
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      onHandleChange: handleChange
    }, null, 8, ["modelValue", "searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("em", _hoisted_7, _toDisplayString(statitiscal.value && statitiscal.value.totalCount ? statitiscal.value.totalCount : 0), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("em", _hoisted_11, _toDisplayString(statitiscal.value && statitiscal.value.replyOneCount
                ? statitiscal.value.replyOneCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("em", _hoisted_14, _toDisplayString(statitiscal.value && statitiscal.value.replyOnePercent
                ? statitiscal.value.replyOnePercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("em", _hoisted_18, _toDisplayString(statitiscal.value && statitiscal.value.replyThreeCount
                ? statitiscal.value.replyThreeCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("em", _hoisted_21, _toDisplayString(statitiscal.value && statitiscal.value.replyThreePercent
                ? statitiscal.value.replyThreePercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("em", _hoisted_25, _toDisplayString(statitiscal.value && statitiscal.value.replyFiveCount
                ? statitiscal.value.replyFiveCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("em", _hoisted_28, _toDisplayString(statitiscal.value && statitiscal.value.replyFivePercent
                ? statitiscal.value.replyFivePercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("em", _hoisted_32, _toDisplayString(statitiscal.value && statitiscal.value.replyTenCount
                ? statitiscal.value.replyTenCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("em", _hoisted_35, _toDisplayString(statitiscal.value && statitiscal.value.replyTenPercent
                ? statitiscal.value.replyTenPercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("em", _hoisted_39, _toDisplayString(statitiscal.value && statitiscal.value.dayDeleteCount
                ? statitiscal.value.dayDeleteCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("em", _hoisted_42, _toDisplayString(statitiscal.value && statitiscal.value.dayDeletePercent
                ? statitiscal.value.dayDeletePercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("em", _hoisted_46, _toDisplayString(statitiscal.value && statitiscal.value.weekDeleteCount
                ? statitiscal.value.weekDeleteCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("em", _hoisted_49, _toDisplayString(statitiscal.value && statitiscal.value.weekDeletePercent
                ? statitiscal.value.weekDeletePercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("em", _hoisted_53, _toDisplayString(statitiscal.value && statitiscal.value.funds0wTo5wCount
                ? statitiscal.value.funds0wTo5wCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("em", _hoisted_56, _toDisplayString(statitiscal.value && statitiscal.value.funds0wTo5wPercent
                ? statitiscal.value.funds0wTo5wPercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("em", _hoisted_60, _toDisplayString(statitiscal.value && statitiscal.value.funds5wTo10wCount
                ? statitiscal.value.funds5wTo10wCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("em", _hoisted_63, _toDisplayString(statitiscal.value && statitiscal.value.funds5wTo10wPercent
                ? statitiscal.value.funds5wTo10wPercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("em", _hoisted_67, _toDisplayString(statitiscal.value && statitiscal.value.funds10wCount
                ? statitiscal.value.funds10wCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _createElementVNode("em", _hoisted_70, _toDisplayString(statitiscal.value && statitiscal.value.funds10wPercent
                ? statitiscal.value.funds10wPercent
                : '-'), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "newCustomResource",
      downFilename: "质量统计表.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick)
    }, {
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(scope.row.duration)), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})